"use client";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import ButtonComponent from "../Button";
import ModalComponent from "../Modal";

const ModalAlert = ({
  open,
  image,
  title,
  description,
  onButtonClick,
  showClose,
  onPressClose,
  closeButtonRequired = false,
  buttonLabel = "Proceed",
}) => {
  return (
    <ModalComponent open={open} closeButtonRequired={closeButtonRequired}>
      <Stack
        spacing={3}
        padding={2}
        alignItems="center"
        justifyContent={"center"}
      >
        {showClose && (
          <Image
            src={IMAGES.close}
            alt="Close"
            onClick={() => onPressClose()}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: 5,
              right: 10,
            }}
            // height={25}
            // width={25}
          />
        )}
        <Box
          sx={{
            width: { xs: 250, sm: 300, md: 350 },
            height: { xs: 150, sm: 250, md: 300 },
            position: 'relative'
          }}
        >
          <Image
            src={image || IMAGES.rejectedLoan}
            alt="Modal Image"
            fill
            style={{ objectFit: 'contain' }}
          />
        </Box>
       {title && (
        <Typography
          align="center"
          fontWeight={{ md: 700, xs: 500 }}
          fontSize={{ md: "24px", xs: "16px" }}
          color={WEB_COLORS.darkTeal}
          display={title ? "block" : "none"}
        >
          {title}
        </Typography>
       )}
        <Typography
          align="center"
          fontWeight={400}
          color={WEB_COLORS.primary}
          fontSize={{ xs: 15, md: 20 }}
        >
          {description}
        </Typography>
        <Stack minWidth={{ xs: 150, sm: 250, md: 300 }}>
          <ButtonComponent onClick={() => onButtonClick()}>
            {buttonLabel}
          </ButtonComponent>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default ModalAlert;
